export const PATH_SIGN_IN = "/signin";
export const PATH_REGISTER = "/register";
export const PATH_ACCOUNT = "/account";
export const PATH_PASSWORD_FORGET = "/pw-forget";
export const PATH_ADMIN_CREATORS = "/admin";//Done
export const PATH_ADMIN_PARTICIPANTS = "/admin/participants";
export const PATH_ADMIN_STATS = "/admin/usage-statistics";
export const PATH_ADMIN_IMPORT = '/admin/library-import';

export const PATH_OVERVIEW = "/overview";//Done
export const PATH_GAME_BUILDER = '/trail-builder';//Done
export const PATH_CREATOR_TEMPLATES = '/creator-templates';//Done
export const PATH_ACTIVITY_LIBRARY = "/utekirke-templates";//Done
export const PATH_QUESTION_LIBRARY = '/question-library';
export const PATH_CLOSED_TRAILS = "/closed-trails";

export const PAGE_OVERVIEW = 1;
export const PAGE_MY_ACTIVITES = 2;
export const PAGE_ACTIVITY_LIBRARY = 3;
export const PAGE_QUESTION_LIBRARY = 4;
export const PAGE_CLOSED_TRAILS = 5;
export const PAGE_ADMIN = 6;
